import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const MatchPeriodSchema = withDefaults({
  type: 'match-period',
  fields: [
    {
      kind: 'attribute',
      name: 'startDate',
    },
    {
      kind: 'attribute',
      name: 'endDate',
    },
    {
      kind: 'attribute',
      name: 'periodName',
    },
    {
      kind: 'belongsTo',
      name: 'matchPlan',
      type: 'match-plan',
      options: {
        async: false,
        inverse: 'matchPeriods',
      },
    },
  ],
});

export default MatchPeriodSchema;
